import React, { Component } from 'react';
import {actionArray} from '../../utils/allActionsArray.json';
import './iamExAcTitleBar.css';

class IamExTitleBar extends Component {

  state = {
    inputAction: ''
  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="IamExTitleBarPage">
        <h1>
                    IAM Audit
        </h1>
        <input className="inputAction" list="actions" name="action" value={this.state.inputAction} onChange={this.handleInput} onKeyDown={this.handleEnterPress} placeholder="Search..."/>
        <datalist id="actions">
          {actionArray.map(action => {
            return <option key={`option-${action}`} value={`${action}`}></option>;
          })}
        </datalist>
        <button onClick={this.handleSubmit}>Submit</button>
      </div>
    );

  };

    handleInput = e => {
      this.setState({[e.target.className]: e.target.value});
    };

    handleEnterPress = e => {
      if (e.key === 'Enter') this.handleSubmit();
    };

    handleSubmit = e => {
      this.props.manageHeaders(this.state.inputAction, 'add');
    }

};

export default IamExTitleBar;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExActions/iamExAcTitleBar/iamExAcTitleBar.js